import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { adminApi } from "../../../../../../../../../services/Api/Admin/adminApi";
import { SyncCompaniesFormProps } from "../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	isShown: boolean;
	onHide: () => void;
}

const SyncCompaniesModalForm = ({ isShown, onHide }: Props) => {
	const { t } = useTranslation("admin");
	const [loading, setLoading] = useState<boolean>(false);
	const { addFlash, addSuccessFlash } = useFlash();
	const form = useForm<SyncCompaniesFormProps>({
		criteriaMode: "all",
		defaultValues: {
			types: [],
		},
	});
	const {
		handleSubmit,
		setError,
		formState,
		formState: { errors },
		control,
	} = form;
	const typeOptions = [
		{
			id: "CHARGEBEE",
			label: "Chargebee",
		},
		{
			id: "INTERCOM",
			label: "Intercom",
		},
	];

	const onSyncCompanies = handleSubmit(async (data) => {
		setLoading(true);
		try {
			await adminApi.syncCompanies(data);
			addSuccessFlash(t("lib:common.flash.completed"));
			onHide();
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal onHide={onHide} show={isShown}>
			<FormDirty onSubmit={onSyncCompanies} formState={formState} key="sync-companies-modal-form">
				<Modal.Header closeButton>
					<Modal.Title>{t("modules.tool.field.sync_companies_modal.title")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormSelectGroup
						name="types"
						isMulti
						getOptionValue={(option) => option.id}
						getOptionLabel={(option) => option.label}
						options={typeOptions}
						label={t("lib:common.word.type")}
						errors={errors}
						control={control}
						data-testid="types"
					/>
				</Modal.Body>
				<Modal.Footer>
					<ButtonLoading loading={loading} type="submit" onClick={onSyncCompanies}>
						{t("common.action.sync", { ns: "lib" })}
					</ButtonLoading>
					<Button variant="light" onClick={onHide}>
						{t("common.action.cancel", { ns: "lib" })}
					</Button>
				</Modal.Footer>
			</FormDirty>
		</Modal>
	);
};

export default SyncCompaniesModalForm;
